import * as THREE from 'three';
import { View3dGlobal } from '.';
import * as marietta from '../..';
import { webcadDefines } from './index';

// import { Loader } from './loader/Loader';
import * as ModelLoader from './loader';

/* ModelInfo
 * 設備・家具配置情報.
 */
export class ModelInfo {
    private _id: string;
    private _type: string;
    private _name: string;
    private _idthreed: string;

    private _position: THREE.Vector3;
    private _rotation: THREE.Vector3;
    private _scale: THREE.Vector3;


    // private _reverse: boolean;
    private _layer: string;
    private _url: string;
    private _thumbnail: string;
    private _uuid: string;

    private _typeExtras: string;
    private _subType: string;

    constructor(type?: webcadDefines.PartType, element?: any) {
        this._position = new THREE.Vector3();
        this._rotation = new THREE.Vector3();
        this._scale = new THREE.Vector3();

        if (type == null && element == null) {
            return;
        }
        this.code = element.code;

        if (element.translate) {
            this._position.set(element.translate[0], element.translate[1], element.translate[2]);
        }
        if (element.rotation) {
            this._rotation.set(element.rotation[0], element.rotation[1], element.rotation[2]);
        }
        if (element.scale) {
            this._scale.set(element.scale[0], element.scale[1], element.scale[2]);
        }

        // this.reverse = element.reverse;
        this.layer = element.layer;
        this.idthreed = element.idthreed;
        this.name = element.name;
        this.uuid = element.guid;
        this.type = String(type);

        this._typeExtras = element.type;
        this._subType = element.sub_type;
    }

    public get code(): string { return this._id; }
    public set code(val: string) { this._id = val; }
    public get name(): string { return this._name; }
    public set name(val: string) { this._name = val; }
    public get type(): string { return this._type; }
    public set type(val: string) { this._type = val; }
    public get idthreed(): string { return this._idthreed; }
    public set idthreed(val: string) { this._idthreed = val; }

    public get translateX(): number { return this._position.x; }
    public get translateY(): number { return this._position.y; }
    public get translateZ(): number { return this._position.z; }
    public get rotationX(): number { return this._rotation.x; }
    public get rotationY(): number { return this._rotation.y; }
    public get rotationZ(): number { return this._rotation.z; }
    public get scaleX(): number { return this._scale.x; }
    public get scaleY(): number { return this._scale.y; }
    public get scaleZ(): number { return this._scale.z; }

    public get scale():THREE.Vector3 { return this._scale };

    // public get reverse(): boolean { return this._reverse; }
    // public set reverse(val: boolean) { this._reverse = val; }
    public get layer(): string { return this._layer; }
    public set layer(val: string) { this._layer = val; }
    public get url(): string { return this._url; }
    public set url(val: string) { this._url = val; }
    public get thumbnail(): string { return this._thumbnail; }
    public set thumbnail(val: string) { this._thumbnail = val; }

    public get typeExtras(): string { return this._typeExtras; }
    public set typeExtras(val: string) { this._typeExtras = val; }
    public get subType(): string { return this._subType; }
    public set subType(val: string) { this._subType = val; }

    public get uuid(): string {
        return this._uuid;
    }
    public set uuid(value: string) {
        this._uuid = value;
    }

    public setTranslate(x: number, y: number, z: number) {
        this._position.set(x, y, z);
    }

    public setRotation(x: number, y: number, z: number) {
        this._rotation.set(x, y, z);
    }

    public setScale(x: number, y: number, z: number) {
        this.scale.set(x, y, z);
    }

    private _matrix;
    public setMatrix(mat: THREE.Matrix4) {
        this._matrix = mat.clone();
    }
    public getMatix() {
        return this._matrix;
    }

    public setupURL3D(): ModelInfo {
        let id = this.code;
        this.thumbnail = `${id}_thumbnail.png`;


        // this.url = marietta.webcad.WebCADGlobal.covertToNoCacheURL(`${dir + id}.dae`);
        // GLTF暫定
        const dir = View3dGlobal.shared.itemDir;
        if (this.idthreed && this.idthreed != '') id = this.idthreed;
        if (ModelLoader.Loader.supporGTLF) {
            this.url = marietta.webcad.WebCADGlobal.covertToNoCacheURL(`${dir}gltf/${id}.gltf`);
        }
        return this;
    }
    //暫定
    public url_model3d(): string {
        const dir = View3dGlobal.shared.itemDir;
        const id = (this.idthreed && this.idthreed != '') ? this.idthreed : this.code;
        const geneID = this.getURLGeneral(this.code);
        if (geneID) {
            return marietta.webcad.WebCADGlobal.covertToNoCacheURL(`${dir}${geneID}.glb`);
        }
        return marietta.webcad.WebCADGlobal.covertToNoCacheURL(`${dir}${id}.glb`);
    }

    /**
     * 汎用部品のURL取得
     */
    private getURLGeneral(id: string): string | null {
        if (['equ28_01', 'equ28_04', 'equ28_13', 'equ28_16'].some((geneID) => id === geneID))   return 'fur28_2';
        if (['equ28_02', 'equ28_05', 'equ28_14', 'equ28_17'].some((geneID) => id === geneID))   return 'fur28_02_wall';
        if (['equ28_03', 'equ28_06', 'equ28_15', 'equ28_18'].some(((geneID) => id === geneID))) return 'fur28_2_ceiling';
        if (['equ28_07', 'equ28_10'].some((geneID) => id === geneID))   return 'fur28_03';
        if (['equ28_08', 'equ28_11'].some((geneID) => id === geneID))   return 'fur28_03_wall';
        if (['equ28_09', 'equ28_12'].some(((geneID) => id === geneID))) return 'fur28_03_ceiling';
        if (['equ15_02', 'equ15_03'].some((geneID) => geneID === id))   return 'equ15_01';
        if (['fur35_01'].some((geneID) => geneID === id)) return 'fur35_01';
        return null;
    }

    public isValid(): boolean {
        if (this.code == 'lig06_02') return false;
        return true;
    }
}

